import 'css-chunk:src/cms/snapshot/snapshot.module.scss';export default {
  "heading-xxl": "snapshot-module__heading-xxl___EI4Qb",
  "wrapper": "snapshot-module__wrapper___dohcZ",
  "heading-xl": "snapshot-module__heading-xl___4VvZw",
  "heading-lg": "snapshot-module__heading-lg___AOxLV",
  "heading-md": "snapshot-module__heading-md___Q7Zgq",
  "heading-sm": "snapshot-module__heading-sm___pK8ff",
  "heading-xs": "snapshot-module__heading-xs___1R-Rj",
  "body-one": "snapshot-module__body-one___ucshs",
  "body-two": "snapshot-module__body-two___wc1z3",
  "body-three": "snapshot-module__body-three___cvwkO",
  "body-four": "snapshot-module__body-four___F7qVf",
  "overline-one": "snapshot-module__overline-one___pKFyL",
  "overline-two": "snapshot-module__overline-two___dAnYS",
  "overline-three": "snapshot-module__overline-three___bmb2L",
  "strong": "snapshot-module__strong___zgBmz",
  "em": "snapshot-module__em___CC2nR",
  "figcaption": "snapshot-module__figcaption___6CNur",
  "no-margin": "snapshot-module__no-margin___0Z3Vs",
  "snapshot": "snapshot-module__snapshot___8TPjq",
  "snapshotItem": "snapshot-module__snapshotItem___pI27T",
  "snapshotItemIcon": "snapshot-module__snapshotItemIcon___Lumgn",
  "snapshotItemContent": "snapshot-module__snapshotItemContent___CDS15"
};